import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { isMobile, isSafari, isChrome } from "react-device-detect";

import Icon from "../Icon";

/* Constants */
import { signUpsPaths } from "../../constants";

/* Actions */
import { adjustProfileImage, toggleBurgerStatus, toggleBurgerMenu, setProfileBuilderFinishLine, setCVPreview, setDeleteAccount, setPasswordChanged, setDetailsChanged, setLogOut, setAlert, setDeleteLocalYachtAccount, setViewListing } from "../../redux/actions/misc";
import { toggleEmailVerifiedAlert, toggleResendEmail } from "../../redux/actions/initial-setup";
import { updateUserProfile, setAuth, setUserData } from "../../redux/actions/user";
import { setJobs, removeJob } from "../../redux/actions/job";
import { setApplications } from "../../redux/actions/application";
import { removeCandidateFromTheList, setListing } from "../../redux/actions/admin";

/* Components */
import OnlineCV from "../../pages/DashboardCandidate/components/CV/components/OnlineCV";
import SelectAvailability from "../SelectAvailability";
import InitialSetupBase from "../InitialSetupBase";
import SidebarDownloads from "../SidebarDownloads";
import SelectLocation from "../SelectLocation";
import NavigationBar from "../NavigationBar";
import VerifyEmail from "../VerifyEmail";
import AdjustPhoto from "../AdjustPhoto";
import EditPhoto from "../EditPhoto";
import Overlay from "../Overlay";
import SidebarCandidate from "../SidebarCandidate";
import ConfirmModal from "../ConfirmModal";
import ImpersonationBanner from "../ImpersonationBanner";

import { SidebarMenuButton, SidebarMenuSubButton } from "../SidebarMenuButtons";

/* API requests */
import { uploadAvatar, updateCandidate } from "../../api-requests/candidate";
import { logoutUser, deleteUserCandidate } from "../../api-requests/user";
import { handlePutForward, rejectApplication, restoreApplication } from "../../api-requests/application";
import { deleteYacht } from "../../api-requests/yacht";
import { handleYachtIcon, handleYachtSize, handleYachtType, handleJobPostTitle, handleYachtAge, handleYachtBuildRegion, handleVisas, handleContractType, handleStartDate } from "../../helpers/job";
import { handleMultiple, handleMultipleQualifications } from "../../helpers/candidate";
import { archiveJob, getJob } from "../../api-requests/job";

class Page extends Component {

    constructor(props) {
        super(props);

        this.state = {
            downloads: false,
            showSaved: false,
            archiveTargetId: null,
            isArchiving: false,
        };
    }

    requestArchiveListing = (_id) => this.setState({ archiveTargetId: _id });

    cancelArchiveListing = () => {
        if (this.state.isArchiving) return;
        this.setState({ archiveTargetId: null });
    };

    confirmArchiveListing = () => {
        const id = this.state.archiveTargetId;
        if (!id || this.state.isArchiving) return;
        this.setState({ isArchiving: true });
        return this.archiveListing(id)
            .then(() => this.setState({ archiveTargetId: null, isArchiving: false }))
            .catch(() => this.setState({ isArchiving: false }));
    };

    componentDidMount() {
        // Reset any toast/alert flags that may be lingering from a previous route.
        // Each toast has its own setTimeout cleanup, but if the user navigates
        // away mid-flight the flag stays "true" and re-shows on the next page.
        if (this.props.misc.detailsChanged) this.props.setDetailsChanged(false);
        if (this.props.misc.passwordChanged) this.props.setPasswordChanged(false);
        if (this.props.misc.showAlert) this.props.setAlert("", "success", false);
        if (this.props.initialSetup.verified) this.props.toggleEmailVerifiedAlert();
        if (this.props.initialSetup.resend) this.props.toggleResendEmail(false);
    }

    componentDidUpdate(prevProps) {
        const prev = prevProps.user.autoSavedAt;
        const now = this.props.user.autoSavedAt;
        if (now && now !== prev) {
            this.setState({ showSaved: true });
            clearTimeout(this._savedTimer);
            this._savedTimer = setTimeout(() => this.setState({ showSaved: false }), 2000);
        }
    }

    componentWillUnmount() {
        clearTimeout(this._savedTimer);
    }

    handleImageSave = (editor, id) => {

        if (editor) {
            const canvasScaled = editor.getImageScaledToCanvas();
            return canvasScaled.toBlob((blob) => {
                return uploadAvatar(id, blob)
                    .then(result => {
                        const body = [
                            { propName: "profileImage", value: result.data },
                        ];
                        this.props.updateUserProfile(body);
                        return this.props.adjustProfileImage(false);
                    });
            },
            "image/jpeg", 1);
        }

    }

    handleEditPhoto = (burgerStatus, photoStatus) => {

        this.props.toggleBurgerMenu(burgerStatus);

        return setTimeout(() => {
            this.props.toggleBurgerStatus(burgerStatus);
            return this.props.adjustProfileImage(photoStatus);
        }, 300);

    }

    dismissBurgerMenu = (status) => {

        this.props.toggleBurgerMenu(status);

        return setTimeout(() => {
            return this.props.toggleBurgerStatus(status);
        }, 300);

    }

    handleLogout = (status, history) => {

        this.props.toggleBurgerStatus(status);
        this.props.toggleBurgerMenu(status);

        this.props.setLogOut(status);
        this.props.setUserData(null);
        this.props.setAuth(status);

        logoutUser();

        return history.push("/");

    } 

    handleApply = (history) => {

        if (history) history.push("/profile");
        
        return this.props.setCVPreview(false);

    }

    handleDeleteAccount = (user, admin) => {

        if (user.userType === "Candidate") {
            return deleteUserCandidate(user)
                .then(result => {
                    if (result.success) {
                        if (admin) {

                            let message = `${user.firstName} ${user.lastName} has been deleted!`;
                            
                            this.props.setAlert(message, "success", true)
                            this.props.setDeleteAccount(false, false);

                            if (user?.profile?.isVerified) {
                                this.props.history.push("/crew");
                            } else {
                                this.props.history.push("/sign-ups");
                            }

                            return setTimeout(() => {
                                return this.props.setAlert(message, "success", false)
                            }, 2700);

                        } else {
                            logoutUser();
                            this.props.setUserData(null);
                            this.props.setAuth(false);
                            this.props.history.push("/");
                            return this.props.setDeleteAccount(false);
                        }
                    }
                    return;
                });
        }

    }

    handleDeleteLocalYachtAccount = (id) => {

        return deleteYacht(id)
            .then(_ => {

                this.props.setDeleteLocalYachtAccount(false, "");
                this.props.history.push("/yachts");
                this.props.setAlert("Local yacht deleted successfully!", "success", true);
                
                return setTimeout(() => {
                    return this.props.setAlert("Local yacht deleted successfully!", "success", false);
                }, 3000);

            });

    }

    showDeleteAccountModal = () => {

        this.dismissBurgerMenu(false);

        return this.props.setDeleteAccount(true, true)

    }

    handleReject = (user, history) => {

        this.dismissBurgerMenu(false);

        let message = `${user.firstName} ${user.lastName} rejected!`;
        let body = [
            { propName: "requestedVerification", value: false },
            { propName: "requestedVerificationDate", value: null },
            { propName: "isRejected", value: true },
        ];

        return updateCandidate(user.profile._id, body)
            .then(_ => {
                history.push("/sign-ups");
                this.props.setAlert(message, "success", true);

                return setTimeout(() => {
                    return this.props.setAlert(message, "success", false);
                }, 2700);
            });

    }

    handleVerify = (user, history) => {

        this.dismissBurgerMenu(false);

        let message = `${user.firstName} ${user.lastName} verified!`;
        let body = [
            { propName: "isVerified", value: true },
        ];

        return updateCandidate(user.profile._id, body)
            .then(_ => {
                history.push("/sign-ups");
                this.props.setAlert(message, "success", true);

                return setTimeout(() => {
                    return this.props.setAlert(message, "success", false);
                }, 2700);

            });

    }

    archiveListing = (_id) => {

        this.dismissBurgerMenu(false);

        return archiveJob(_id)
            .then(result => {
                if (!result?.success) {
                    this.props.setAlert("Failed to archive listing.", "error", true);
                    setTimeout(() => this.props.setAlert("Failed to archive listing.", "error", false), 2700);
                    return Promise.reject(new Error("archive_failed"));
                }
                if (this.props.match.path.includes("/yachts")) {
                    this.props.history.push(`/yachts/listings/${this.props.match.params.yachtId}/archived`);
                } else {
                    this.props.history.push(`/listings/archived`);
                }
                this.props.setAlert("Listing archived successfully!", "success", true);
                return setTimeout(() => {
                    this.props.setAlert("Listing archived successfully!", "success", false);
                }, 2700);
            });

    }

    viewListing = (_id) => {

        this.dismissBurgerMenu(false);

        return getJob(_id)
            .then(result => {
                this.props.setListing(result);
                return this.props.setViewListing(true);
            });

    }

    putForward = (_id) => {

        this.dismissBurgerMenu(false);

        return handlePutForward(_id)
            .then(result => {
                if (this.props.match.path.includes("/yachts")) {
                    this.props.history.push(`/yachts/listings/${this.props.match.params.yachtId}/applications/${this.props.match.params.jobId}/${result.nextStage}`);
                } else {
                    this.props.history.push(`/listings/applications/${this.props.match.params.yachtId}/job/${this.props.match.params.jobId}/${result.nextStage}`);
                }
                this.props.setAlert("Candidate put forward successfully!", "success", true);
                return setTimeout(() => {
                    this.props.setAlert("Candidate put forward successfully!", "success", false);
                }, 2700);
            });

    }

    rejectApplication = (_id) => {

        this.dismissBurgerMenu(false);

        return rejectApplication(_id)
            .then(_ => {
                if (this.props.match.path.includes("/yachts")) {
                    this.props.history.push(`/yachts/listings/${this.props.match.params.yachtId}/applications/${this.props.match.params.jobId}/rejected`);
                } else {
                    this.props.history.push(`/listings/applications/${this.props.match.params.yachtId}/job/${this.props.match.params.jobId}/rejected`);
                }
                this.props.setAlert("Candidate rejected successfully!", "success", true);
                return setTimeout(() => {
                    this.props.setAlert("Candidate rejected successfully!", "success", false);
                }, 2700);
            });

    }

    restoreApplication = (_id) => {

        this.dismissBurgerMenu(false);

        return restoreApplication(_id)
            .then(_ => {
                if (this.props.match.path.includes("/yachts")) {
                    this.props.history.push(`/yachts/listings/${this.props.match.params.yachtId}/applications/${this.props.match.params.jobId}`);
                } else {
                    this.props.history.push(`/listings/applications/${this.props.match.params.yachtId}/job/${this.props.match.params.jobId}`);
                }
                this.props.setAlert("Application restored successfully!", "success", true);
                return setTimeout(() => {
                    this.props.setAlert("Application restored successfully!", "success", false);
                }, 2700);
            });

    }

    render() {

        const { data } = this.props.user;
        const addExtraSpace = isMobile && (isSafari || isChrome);

        let visas;
        let contractType;
        let startDate;

        if (this.props.misc.viewListing) {
            visas = handleVisas(this.props.admin.listing);
            contractType = handleContractType(this.props.admin.listing);
            startDate = handleStartDate(this.props.admin.listing);
        }

        return(
            <div className="page-container" style={{ overflow: "hidden" }}>
                {data?._impersonatedBy &&
                    <ImpersonationBanner
                        candidateName={`${data.firstName || ""} ${data.lastName || ""}`.trim() || data.email}
                    />
                }
                {!this.props.hideNavbar && <NavigationBar {...this.props} />}
                <main>{this.props.children}</main>
                <div className={`auto-saved-indicator${this.state.showSaved ? " visible" : ""}`}>
                    <span className="auto-saved-indicator-dot" />
                    <span className="auto-saved-indicator-text">Saved</span>
                </div>
                <div className={this.props.misc.showAlert ? "email-verified-alert-container show" : "email-verified-alert-container"}>
                    <div className={`email-verified-alert${this.props.misc.alertStyle === "error" ? " error" : ""}`} onClick={() => this.props.setAlert(this.props.misc.alertMessage, this.props.misc.alertStyle, false)}>
                        <p>{this.props.misc.alertMessage}</p>
                    </div>
                </div>
                <div className={this.props.initialSetup.verified ? "email-verified-alert-container show" : "email-verified-alert-container"}>
                    <div className="email-verified-alert" onClick={() => this.props.toggleEmailVerifiedAlert()}>
                        <p>Email successfully verified!</p>
                    </div>
                </div>
                <div className={this.props.initialSetup.resend ? "email-verified-alert-container show" : "email-verified-alert-container"}>
                    <div className="email-verified-alert" onClick={() => this.props.toggleResendEmail(false)}>
                        <p>New email sent!</p>
                    </div>
                </div>
                <div className={this.props.misc.passwordChanged ? "email-verified-alert-container show" : "email-verified-alert-container"}>
                    <div className="email-verified-alert" onClick={() => this.props.setPasswordChanged(false)}>
                        <p>Password successfully updated!</p>
                    </div>
                </div>
                <div className={this.props.misc.detailsChanged ? "email-verified-alert-container show" : "email-verified-alert-container"}>
                    <div className="email-verified-alert" onClick={() => this.props.setDetailsChanged(false)}>
                        <p>Basic details successfully updated!</p>
                    </div>
                </div>
                {data?.profile?.profileType === "build" && !data?.isVerified &&
                    <Overlay>
                        <VerifyEmail email={data.email} userID={data._id} resend={this.props.toggleResendEmail} noexit={true} />
                    </Overlay>
                }
                {this.props.misc.adjustProfileImage &&
                    <Overlay>
                        <div className="edit-photo-modal-container">
                            <span className="edit-photo-x" onClick={() => this.props.adjustProfileImage(false)}><Icon name="x" size={22} /></span>
                            <InitialSetupBase title={"Edit Photo"} description={"You can adjust or replace your professional portrait photo."}>
                                <AdjustPhoto />
                                <div className="edit-photo-action-buttons-container margin-top-2x">
                                    <div className="edit-photo-action-buttons-save" onClick={() => this.handleImageSave(this.props.initialSetup.editor, this.props.user.data.profile._id)}>
                                        <p className="edit-photo-action-buttons-save-title">Save</p>
                                    </div>
                                    <div className="edit-photo-action-buttons-cancel" onClick={() => this.props.adjustProfileImage(false)}>
                                        <p className="edit-photo-action-buttons-cancel-title">Cancel</p>
                                    </div>
                                </div>
                            </InitialSetupBase>
                        </div>
                    </Overlay>
                }
                {this.props.misc.profileBuilderFinishLine &&
                    <Overlay>
                        <div className="celebration-modal" role="dialog" aria-modal="true" aria-labelledby="celebration-modal-title">
                            <div className="celebration-modal-icon" aria-hidden="true">
                                <svg width={40} height={40} viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2 className="celebration-modal-title" id="celebration-modal-title">Your profile is ready</h2>
                            <p className="celebration-modal-body">Nice work. We'll match you to roles as they come in - you can now apply to any role that catches your eye.</p>
                            <Link to={"/"} onClick={() => this.props.setProfileBuilderFinishLine(false)} className="celebration-modal-cta">
                                See open roles
                                <svg width={16} height={16} viewBox="0 0 24 24" fill="none" style={{marginLeft: 8}}>
                                    <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </Link>
                            <button type="button" className="celebration-modal-dismiss" onClick={() => this.props.setProfileBuilderFinishLine(false)}>Not now</button>
                        </div>
                    </Overlay>
                }
                {this.props.misc.burgerStatus && !this.props.user.isLoggedIn &&
                    <Overlay>
                        <div className={this.props.misc.showBurger ? "burger-menu-master-container expanded" : "burger-menu-master-container"}>
                            <div className="burger-menu-container">
                                <div className="burger-menu-header-container">
                                    <div className="burger-menu-header-icon-container" onClick={() => this.dismissBurgerMenu(false)}>
                                        <span className="burger-menu-header-icon"><Icon name="chevron-down" size={16} /></span>
                                    </div>
                                </div>
                                <SidebarMenuSubButton active={this.props.match.path.includes("/find-jobs")} title={"Find Jobs"} path={"/find-jobs"} collapse={this.dismissBurgerMenu} />
                                <SidebarMenuSubButton active={this.props.match.path.includes("/looking-for-crew")} title={"Looking for Crew?"} path={"/looking-for-crew"} collapse={this.dismissBurgerMenu} />
                                <SidebarMenuSubButton active={this.props.match.path.includes("/about-us")} title={"About Us"} path={"/about-us"} collapse={this.dismissBurgerMenu} />
                                <SidebarMenuSubButton active={this.props.match.path.includes("/cv-advice")} title={"CV Advice"} path={"/cv-advice"} collapse={this.dismissBurgerMenu} />
                                <SidebarMenuSubButton active={this.props.match.path.includes("/contact-us")} title={"Contact Us"} path={"/contact-us"} collapse={this.dismissBurgerMenu} />    
                            </div>
                            <div className="burger-menu-retainer" onClick={() => this.dismissBurgerMenu(false)}></div>
                        </div>
                    </Overlay>
                }
                {this.props.misc.burgerStatus && this.props.user.isLoggedIn &&
                    <Overlay>
                        <div className={this.props.misc.showBurger ? "burger-menu-master-container expanded" : "burger-menu-master-container"}>
                            <div className="burger-menu-container">
                                <div className="burger-menu-header-container">
                                    <div className="burger-menu-header-icon-container" onClick={() => this.dismissBurgerMenu(false)}>
                                        <span className="burger-menu-header-icon"><Icon name="chevron-down" size={16} /></span>
                                    </div>
                                </div>
                                <div className="burger-menu-scroll-container">
                                    {data?.userType !== "Admin" &&
                                        <div style={{padding: 20, paddingBottom: 0}}>
                                            <SidebarCandidate match={this.props.match} collapse={this.dismissBurgerMenu} />
                                        </div>
                                    }
                                    {data?.userType === "Admin" &&
                                        <div style={{paddingLeft: 20, paddingRight: 20}}>
                                            <SidebarMenuButton active={signUpsPaths.includes(this.props.match.path) || this.props.match.path.includes("/sign-ups/profile")} title={"Sign Ups"} path={"/sign-ups"} userType={"Admin"} num={this.props.admin.completedUsersCount} collapse={this.dismissBurgerMenu} />
                                            <div className="margin-top-20px">
                                                <SidebarMenuButton active={this.props.match.path.includes("/crew")} title={"Crew"} path={"/crew"} collapse={this.dismissBurgerMenu} />
                                            </div>
                                            <div className="margin-top-20px">
                                                <SidebarMenuButton active={this.props.match.path.includes("/yachts")} title={"Yachts"} path={this.props.match.params.yachtId ? "/yachts/edit/"+this.props.match.params.yachtId : "/yachts"} collapse={this.dismissBurgerMenu} />
                                                {(this.props.match.path.includes("/yachts/edit") || this.props.match.path.includes("/yachts/listings")) &&
                                                    <>
                                                        <SidebarMenuSubButton active={this.props.match.path.includes("/yachts/listings")} title={"Listings"} path={"/yachts/listings/"+this.props.match.params.yachtId} collapse={this.dismissBurgerMenu} />
                                                        <SidebarMenuSubButton active={this.props.match.path.includes("/yachts/edit")} title={"Yacht Details"} path={"/yachts/edit/"+this.props.match.params.yachtId} collapse={this.dismissBurgerMenu} />
                                                    </>
                                                }
                                            </div>
                                            <div className="margin-top-20px">
                                                <SidebarMenuButton active={this.props.match.path.includes("/listings") && !this.props.match.path.includes("/yachts")} title={"Listings"} path={"/listings"} collapse={this.dismissBurgerMenu} />
                                            </div>
                                            <div className="margin-top-20px">
                                                <SidebarMenuButton active={this.props.match.path === "/stats"} title={"Stats"} path={"/stats"} collapse={this.dismissBurgerMenu} />
                                            </div>
                                            <div className="margin-top-20px">
                                                <SidebarMenuButton active={this.props.match.path === "/references"} title={"References"} path={"/references"} collapse={this.dismissBurgerMenu} />
                                            </div>
                                            <div className="margin-top-20px">
                                                <SidebarMenuButton active={this.props.match.path === "/jobs"} title={"Jobs"} path={"/jobs"} collapse={this.dismissBurgerMenu} />
                                            </div>
                                            {(this.props.match.path.includes("/sign-ups/profile/") || this.props.match.path.includes("/crew/profile/")) && this.props.admin.cvProfile &&
                                                <>
                                                    <div className="sidebar-admin-actions-container margin-top-20px">
                                                        <div className="sidebar-admin-action-header-container">
                                                            <div className="sidebar-admin-action-wrapper">
                                                                <p>Candidate Actions</p>
                                                            </div>
                                                        </div>
                                                        {!this.props.admin.cvProfile.profile.isVerified &&
                                                            <div className="sidebar-admin-action-button-container" onClick={() => this.handleVerify(this.props.admin.cvProfile, this.props.history)}>
                                                                <div className="sidebar-admin-action-wrapper">
                                                                    <img src={require("../../assets/svgs/verify.svg")} alt="" />
                                                                    <p style={{color: "#1377FF"}}>Verify Candidate</p>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.props.admin.cvProfile.profile.requestedVerification && !this.props.admin.cvProfile.profile.isVerified &&
                                                            <div className="sidebar-admin-action-button-container" onClick={() => this.handleReject(this.props.admin.cvProfile, this.props.history)}>
                                                                <div className="sidebar-admin-action-wrapper">
                                                                    <img src={require("../../assets/svgs/reject.svg")} alt="" />
                                                                    <p style={{color: "#333333"}}>Reject Candidate</p>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div className="sidebar-admin-action-button-container" onClick={() => this.showDeleteAccountModal()}>
                                                            <div className="sidebar-admin-action-wrapper">
                                                                <img src={require("../../assets/svgs/trash.svg")} alt="" />
                                                                <p style={{color: "#EB5757"}}>Delete Account</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="margin-top-20px">
                                                        <SidebarDownloads admin={true} show={this.state.downloads} toggle={() => this.setState({ downloads: !this.state.downloads })} user={this.props.admin.cvProfile} originalCV={this.props.admin.cvProfile.profile.cv} />
                                                    </div>
                                                    <div className="sidebar-admin-return-button-container margin-top-10px">
                                                        <Link to={this.props.admin?.cvProfile?.profile?.isVerified ? "/crew/" : "/sign-ups/"} className="sidebar-admin-return-button-wrapper" onClick={() => this.dismissBurgerMenu(false)}>
                                                            <img src={require("../../assets/svgs/return.svg")} alt="" />
                                                            <p>{this.props.admin?.cvProfile?.profile?.isVerified ? "Return to Crew" : "Return to Sign Ups"}</p>
                                                        </Link>
                                                    </div>
                                                </>
                                            }
                                            {this.props.match.params.tab === "application" && this.props.match.params.applicationId && this.props.admin.cvProfile && this.props.admin.cvApplication &&
                                                <>
                                                    <div className="sidebar-admin-actions-container margin-top-20px">
                                                        <div className="sidebar-admin-action-header-container">
                                                            <div className="sidebar-admin-action-wrapper">
                                                                <p>Candidate Actions</p>
                                                            </div>
                                                        </div>
                                                        {this.props.admin.cvApplication.rejected &&
                                                            <div className="sidebar-admin-action-button-container">
                                                                <div className="sidebar-admin-action-wrapper" onClick={() => this.restoreApplication(this.props.match.params.applicationId)}>
                                                                    <img src={require("../../assets/svgs/put-forward.svg")} alt="" />
                                                                    <p style={{color: "#1377FF"}}>Restore Application</p>
                                                                </div>
                                                            </div>
                                                        }
                                                        {!this.props.admin.cvApplication.rejected &&
                                                            <div className="sidebar-admin-action-button-container">
                                                                <div className="sidebar-admin-action-wrapper" onClick={() => this.rejectApplication(this.props.match.params.applicationId)}>
                                                                    <img src={require("../../assets/svgs/trash.svg")} alt="" />
                                                                    <p style={{color: "#F55D5D"}}>Reject Candidate</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="margin-top-20px">
                                                        <SidebarDownloads admin={true} show={this.state.downloads} toggle={() => this.setState({ downloads: !this.state.downloads })} user={this.props.admin.cvProfile} originalCV={this.props.admin.cvProfile.profile.cv} />
                                                    </div>
                                                </>
                                            }
                                            {this.props.match.path.includes("/yachts/") && this.props.match.params.yachtId  && this.props.match.params.status !== "applications" &&
                                                <div className="delete-local-yacht-account-button margin-top-20px" onClick={() => this.props.setDeleteLocalYachtAccount(true, this.props.match.params.yachtId)}>
                                                    <div className="delete-local-yacht-account-button-icon-container">
                                                        <img src={require("../../assets/svgs/trash.svg")} alt="" />
                                                    </div>
                                                    <div className="delete-local-yacht-account-button-title-container">
                                                        <p>Delete Account</p>
                                                    </div>
                                                </div>
                                            }
                                            {(this.props.match.path === "/yachts/create" || this.props.match.path.includes("/yachts/edit") || this.props.match.path.includes("/yachts/listings")) && this.props.match.params.status !== "add" && this.props.match.params.status !== "applications" &&
                                                <div className="sidebar-admin-return-button-container margin-top-10px">
                                                    <Link to={"/yachts"} className="sidebar-admin-return-button-wrapper" onClick={() => this.dismissBurgerMenu(false)}>
                                                        <img src={require("../../assets/svgs/return.svg")} alt="" />
                                                        <p>Return to Yachts</p>
                                                    </Link>
                                                </div>
                                            }
                                            {(this.props.match.params.status === "add" || this.props.match.params.status === "applications") && !this.props.match.params.applicationId && this.props.match.params.jobId && this.props.match.params.tab !== "application" && this.props.match.params.yachtId &&
                                                <>
                                                    <div className="sidebar-admin-actions-container margin-top-20px">
                                                        <div className="sidebar-admin-action-header-container">
                                                            <div className="sidebar-admin-action-wrapper">
                                                                <p>Listing Actions</p>
                                                            </div>
                                                        </div>
                                                        <Link className="sidebar-admin-action-button-container" to={this.props.match.path.includes("/yachts") ? `/yachts/listings/${this.props.match.params.yachtId}/add?job=${this.props.match.params.jobId}&status=active` : `/listings/add/${this.props.match.params.yachtId}?job=${this.props.match.params.jobId}&status=active`} onClick={() => this.dismissBurgerMenu(false)}>
                                                            <div className="sidebar-admin-action-wrapper">
                                                                <img src={require("../../assets/svgs/edit-dark.svg")} alt="" />
                                                                <p style={{color: "#333333"}}>Edit Listing</p>
                                                            </div>
                                                        </Link>
                                                        <div className="sidebar-admin-action-button-container">
                                                            <div className="sidebar-admin-action-wrapper" onClick={() => this.requestArchiveListing(this.props.match.params.jobId)}>
                                                                <img src={require("../../assets/svgs/end-listing.svg")} alt="" />
                                                                <p style={{color: "#333333"}}>End & Archive Listing</p>
                                                            </div>
                                                        </div>
                                                        <div className="sidebar-admin-action-button-container">
                                                            <div className="sidebar-admin-action-wrapper" onClick={() => this.viewListing(this.props.match.params.jobId)}>
                                                                <img src={require("../../assets/svgs/eye.svg")} alt="" />
                                                                <p style={{color: "#333333"}}>View Listing</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {this.props.match.path.includes("/yachts/") && (this.props.match.params.status === "add" || this.props.match.params.status === "applications") && !this.props.match.params.applicationId && this.props.match.params.tab !== "application" && this.props.match.params.yachtId &&
                                                <div className="sidebar-admin-return-button-container margin-top-10px">
                                                    <Link to={`/yachts/listings/${this.props.match.params.yachtId}`} className="sidebar-admin-return-button-wrapper" onClick={() => this.dismissBurgerMenu(false)}>
                                                        <img src={require("../../assets/svgs/return.svg")} alt="" />
                                                        <p>Return to Listings</p>
                                                    </Link>
                                                </div>
                                            }
                                            {!this.props.match.path.includes("/yachts/") && this.props.match.path.includes("/listings/") && (this.props.match.params.status === "add" || this.props.match.params.status === "applications") && this.props.match.params.tab !== "application" && this.props.match.params.yachtId &&
                                                <div className="sidebar-admin-return-button-container margin-top-10px">
                                                    <Link to={`/listings`} className="sidebar-admin-return-button-wrapper" onClick={() => this.dismissBurgerMenu(false)}>
                                                        <img src={require("../../assets/svgs/return.svg")} alt="" />
                                                        <p>Return to Listings</p>
                                                    </Link>
                                                </div>
                                            }
                                            {this.props.match.path.includes("/yachts/") && this.props.match.params.yachtId && this.props.match.params.jobId && this.props.match.params.applicationId && this.props.match.params.tab === "application" &&
                                                <div className="sidebar-admin-return-button-container margin-top-10px">
                                                    <Link to={`/yachts/listings/${this.props.match.params.yachtId}/applications/${this.props.match.params.jobId}`} className="sidebar-admin-return-button-wrapper" onClick={() => this.dismissBurgerMenu(false)}>
                                                        <img src={require("../../assets/svgs/return.svg")} alt="" />
                                                        <p>Return to Applications</p>
                                                    </Link>
                                                </div>
                                            }
                                            {!this.props.match.path.includes("/yachts/") && this.props.match.params.yachtId && this.props.match.params.jobId && this.props.match.params.applicationId && this.props.match.params.tab === "application" &&
                                                <div className="sidebar-admin-return-button-container margin-top-10px">
                                                    <Link to={`/listings/applications/${this.props.match.params.yachtId}/job/${this.props.match.params.jobId}`} className="sidebar-admin-return-button-wrapper" onClick={() => this.dismissBurgerMenu(false)}>
                                                        <img src={require("../../assets/svgs/return.svg")} alt="" />
                                                        <p>Return to Applications</p>
                                                    </Link>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {data?.userType === "Admin" &&
                                        <div className="sidebar-candidate-menu-container burger-menu-spacer">
                                            <div style={{marginBottom: 10}}>
                                                <SidebarMenuSubButton title={"Log out"} logout={true} handleLogout={this.props.setLogOut} />
                                            </div>
                                        </div>
                                    }
                                    {addExtraSpace &&
                                        <div style={{width: "100%", minHeight: 128}}></div>
                                    }
                                </div>
                            </div>
                            <div className="burger-menu-retainer" onClick={() => this.dismissBurgerMenu(false)}></div>
                        </div>
                    </Overlay>
                }
                {this.props.misc.showCVPreview &&
                    <Overlay>
                        <div className="cv-preview-modal-container">
                            <span className="cv-preview-x" onClick={() => this.props.setCVPreview(false)}><Icon name="x" size={22} /></span>
                            <p className="cv-preview-title">Review your profile <span role="img" aria-label="Check it out!">👇</span></p>
                            <p className="cv-preview-subtitle">Please look over your profile to check it is correct and complete for employers to view it.</p>
                            <div className="margin-top-2x">
                                <OnlineCV user={data} />
                            </div>
                            <div className="cv-preview-modal-buttons-container">
                                <div className="cv-preview-modal-edit-button-container" onClick={() => this.handleApply(this.props.history)}>
                                    <p>Edit Profile</p>
                                </div>
                                <div className="cv-preview-modal-buttons-separator"></div>
                                <div className="cv-preview-modal-confirm-button-container" onClick={() => this.handleApply()}>
                                    <p>Confirm</p>
                                </div>
                            </div>
                        </div>
                        <div style={{minHeight: 150, width: "100%"}}></div>
                    </Overlay>
                }
                {this.props.misc.viewListing && this.props.admin.listing && (() => {
                    const listing = this.props.admin.listing;
                    const yacht = listing.yacht || {};
                    const yachtRows = [
                        yacht.yachtStatus && ["Charter status", yacht.yachtStatus],
                        yacht.age && ["Yacht age", handleYachtAge(yacht.age)],
                        yacht.yachtBuilderCountry && ["Build", handleYachtBuildRegion(yacht.yachtBuilderCountry)],
                        yacht.couples !== undefined && ["Couples considered", yacht.couples ? "Yes" : "No"],
                        yacht.itinerary && yacht.itinerary.length > 0 && ["Itinerary", handleMultiple(yacht.itinerary)],
                        visas && ["Visas required", visas],
                        yacht?.currentLocation?.country && ["Current location", yacht.currentLocation.country],
                        yacht?.homePort?.country && ["Home port", yacht.homePort.country],
                        yacht.smoking !== undefined && ["Smoking policy", yacht.smoking ? "Smoking allowed" : "No smoking"],
                        yacht.tattoo && ["Tattoo policy", yacht.tattoo],
                        yacht.dryBoat !== undefined && ["Dry boat", yacht.dryBoat ? "Yes" : "No"],
                    ].filter(Boolean);
                    const jobRows = [
                        contractType && ["Contract type", contractType],
                        startDate && ["Start date", startDate],
                        listing.cabinStatus && ["Cabin status", listing.cabinStatus],
                        listing.experience && ["Required experience", listing.experience],
                        listing.qualifications && listing.qualifications.length > 0 && ["Qualifications", handleMultipleQualifications(listing.qualifications.map(item => item.name), listing.moreQualifications)],
                    ].filter(Boolean);
                    return (
                        <Overlay>
                            <div className="view-listing-modal-positioner" onClick={(e) => { if (e.target === e.currentTarget) this.props.setViewListing(false); }}>
                                <div className="view-listing-modal" role="dialog" aria-modal="true" aria-labelledby="view-listing-modal-title">
                                    <header className="view-listing-modal-header">
                                        <div className="view-listing-modal-titles">
                                            <p className="view-listing-modal-eyebrow">Listing preview</p>
                                            <h2 className="view-listing-modal-title" id="view-listing-modal-title">{handleJobPostTitle(listing)}</h2>
                                            <p className="view-listing-modal-subtitle">{handleYachtSize(yacht.size)} {handleYachtType(yacht.yachtType)}</p>
                                        </div>
                                        <button type="button" className="view-listing-modal-close" aria-label="Close" onClick={() => this.props.setViewListing(false)}>
                                            <Icon name="x" size={20} />
                                        </button>
                                    </header>

                                    <div className="view-listing-modal-body">
                                        {yachtRows.length > 0 && (
                                            <section className="view-listing-section">
                                                <h3 className="view-listing-section-title">Yacht details</h3>
                                                <dl className="view-listing-dl">
                                                    {yachtRows.map(([label, value], i) => (
                                                        <div className="view-listing-row" key={`y-${i}`}>
                                                            <dt>{label}</dt>
                                                            <dd>{value}</dd>
                                                        </div>
                                                    ))}
                                                </dl>
                                            </section>
                                        )}

                                        {jobRows.length > 0 && (
                                            <section className="view-listing-section">
                                                <h3 className="view-listing-section-title">Job details</h3>
                                                <dl className="view-listing-dl">
                                                    {jobRows.map(([label, value], i) => (
                                                        <div className="view-listing-row" key={`j-${i}`}>
                                                            <dt>{label}</dt>
                                                            <dd>{value}</dd>
                                                        </div>
                                                    ))}
                                                </dl>
                                            </section>
                                        )}

                                        {listing.description && (
                                            <section className="view-listing-section">
                                                <h3 className="view-listing-section-title">Job description</h3>
                                                <p className="view-listing-prose">{listing.description}</p>
                                            </section>
                                        )}

                                        {yacht.notes && (
                                            <section className="view-listing-section">
                                                <h3 className="view-listing-section-title">Yacht notes</h3>
                                                <p className="view-listing-prose">{yacht.notes}</p>
                                            </section>
                                        )}

                                        {listing.notes && (
                                            <section className="view-listing-section">
                                                <h3 className="view-listing-section-title">Job notes</h3>
                                                <p className="view-listing-prose">{listing.notes}</p>
                                            </section>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Overlay>
                    );
                })()}
                {this.props.misc.showDeleteAccount &&
                    <Overlay>
                        <div className="signout-modal" role="dialog" aria-modal="true" aria-labelledby="delete-account-modal-title">
                            <h2 className="signout-modal-title" id="delete-account-modal-title">{this.props.misc.deleteAccountAsAdmin ? "Delete this account?" : "Delete your account?"}</h2>
                            <p className="signout-modal-body">This can't be undone. All profile data, references, documents, and applications will be permanently removed.</p>
                            <div className="signout-modal-actions">
                                <button type="button" className="signout-modal-button signout-modal-button--secondary" onClick={() => this.props.setDeleteAccount(false, false)}>Cancel</button>
                                <button type="button" className="signout-modal-button signout-modal-button--destructive" onClick={this.props.misc.deleteAccountAsAdmin ? () => this.handleDeleteAccount(this.props.admin.cvProfile, true) : () => this.handleDeleteAccount(data, false)}>Delete account</button>
                            </div>
                        </div>
                    </Overlay>
                }
                {this.props.misc.showDeleteLocalYacht &&
                    <Overlay>
                        <div className="signout-modal" role="dialog" aria-modal="true" aria-labelledby="delete-yacht-modal-title">
                            <h2 className="signout-modal-title" id="delete-yacht-modal-title">Delete this yacht account?</h2>
                            <p className="signout-modal-body">This can't be undone. The yacht record, all listings, and any associated data will be permanently removed.</p>
                            <div className="signout-modal-actions">
                                <button type="button" className="signout-modal-button signout-modal-button--secondary" onClick={() => this.props.setDeleteLocalYachtAccount(false, "")}>Cancel</button>
                                <button type="button" className="signout-modal-button signout-modal-button--destructive" onClick={() => this.handleDeleteLocalYachtAccount(this.props.misc.deletedYacht)}>Delete yacht</button>
                            </div>
                        </div>
                    </Overlay>
                }
                {this.props.misc.logOut &&
                    <Overlay>
                        <div className="signout-modal" role="dialog" aria-modal="true" aria-labelledby="signout-modal-title">
                            <h2 className="signout-modal-title" id="signout-modal-title">Sign out?</h2>
                            <p className="signout-modal-body">You'll need to enter your email to sign back in.</p>
                            <div className="signout-modal-actions">
                                <button type="button" className="signout-modal-button signout-modal-button--secondary" onClick={() => this.props.setLogOut(false)}>Cancel</button>
                                <button type="button" className="signout-modal-button signout-modal-button--destructive" onClick={() => this.handleLogout(false, this.props.history)}>Sign out</button>
                            </div>
                        </div>
                    </Overlay>
                }
                <ConfirmModal
                    show={!!this.state.archiveTargetId}
                    title={"End & archive this listing?"}
                    description={"This listing will be moved to the Archived tab. Candidates will no longer be able to apply. You can re-list it later from the Archived tab."}
                    confirmLabel={this.state.isArchiving ? "Archiving…" : "End & archive"}
                    cancelLabel={"Keep listing"}
                    destructive={true}
                    busy={this.state.isArchiving}
                    onConfirm={this.confirmArchiveListing}
                    onCancel={this.cancelArchiveListing}
                />
            </div>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        misc: state.misc,
        user: state.user,
        initialSetup: state.initialSetup,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ setJobs, setApplications, removeCandidateFromTheList, toggleEmailVerifiedAlert, toggleResendEmail, setAuth, setUserData, updateUserProfile, adjustProfileImage,  toggleBurgerStatus, toggleBurgerMenu, setProfileBuilderFinishLine, setCVPreview, removeJob, setDeleteAccount, setPasswordChanged, setDetailsChanged, setLogOut, setAlert, setDeleteLocalYachtAccount, setViewListing, setListing }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);